import { render, staticRenderFns } from "./LegalDocument.vue?vue&type=template&id=2793889e&"
import script from "./LegalDocument.vue?vue&type=script&lang=js&"
export * from "./LegalDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports